import { z } from 'zod'

import { useTranslation } from '@flecto/translations'

import { type OnboardingFormData } from '../types/OnboardingFormData'

export function useOnboardingForm() {
  const { t } = useTranslation('shared', { keyPrefix: 'validation' })

  const validateStringPlain = z.string({
    required_error: t('required'),
    invalid_type_error: t('required'),
  })

  const validateString = validateStringPlain.min(2, { message: t('required') })

  const schema = z.object({
    step_basic_info: z.object({
      first_name: validateString,
      last_name: validateString,
      company_name: validateString,
      qty_employees: validateString,
    }),
    step_business_info: z.object({
      business_category: validateStringPlain.min(1, { message: t('required') }),
      avg_bookings_per_month: validateString,
      systems_to_replace: validateString
        .array()
        .min(1, { message: t('required') }),
      flecto_products_interested_on: validateString.array(),
    }),
    step_location: z.object({
      address: z.object({
        address_country_code: validateString,
        address_postal_code: validateString,
        address_city: validateString,
        address_street: validateString,
      }),
    }),
  })

  const initialValues: OnboardingFormData = {
    step_basic_info: {
      first_name: '',
      last_name: '',
      company_name: '',
      qty_employees: '',
    },
    step_business_info: {
      business_category: '',
      flecto_products_interested_on: [],
      systems_to_replace: [],
      avg_bookings_per_month: '',
    },
    step_location: {
      address: {
        address_country_code: 'PT',
        address_country_name: 'Portugal',
        address_city: '',
        address_street: '',
        address_postal_code: '',
        address_region: '',
        last_selected: '',
        fromGoogle: false,
      },
    },
  }

  return { schema, initialValues }
}
